import { VStack, Divider, useDisclosure } from "@chakra-ui/react"
import Event from './Event'
import ReadOnlyEvent from './ReadOnlyEvent'
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import AssessmentFormBuilder from "./AssessmentFormBuilder"
import BeneficiaryEvent from "components/BeneficiaryEvent"
import { LifeEvent } from "interfaces/lifeEvent"

interface Props {
    nextEvent: LifeEvent
}

const Assessments = ({ nextEvent }: Props) => {
    // const { isOpen: formbuilderOpen, onOpen: formbuilderOnOpen, onClose: formbuilderOnClose } = useDisclosure()
    // const { isOpen: eventOpen, onOpen: eventOnOpen, onClose: eventOnClose } = useDisclosure()
    // const formBuilder = {
    //     isOpen: formbuilderOpen,
    //     onOpen: formbuilderOnOpen,
    //     onClose: formbuilderOnClose,
    // }
    // const event = {
    //     isOpen: eventOpen,
    //     onOpen: eventOnOpen,
    //     onClose: eventOnClose,
    // }

    return (
        <Card
            px="0px"
            pb="22px"
            w="full"
            mb="12px"
        >
            <CardBody h="100%" px="22px">
                <VStack spacing={4} w="full">
                    <ReadOnlyEvent title={nextEvent.name} beginAt={nextEvent.begin_at} />
                    {/* <Event title="Acompanhamento" type="awaiting" event={event} />
                    <Divider w="full" h="1px" />
                    <Event title="Primeiro Acolhimento" type="awaiting" event={event} />
                    <Divider w="full" h="1px" />
                    <Event title="Primeiro Acolhimento" type="available" event={event} formBuilder={formBuilder} /> */}
                </VStack>
            </CardBody>
            {/* <AssessmentFormBuilder isOpen={formbuilderOpen} onClose={formbuilderOnClose} />
            <BeneficiaryEvent isOpen={eventOpen} onClose={eventOnClose} title="Agendamento" /> */}
        </Card>
    )
}

export default Assessments